export default "__VITE_ASSET__DDahBcVz__"